export default __webpack_public_path__ + "61477136ddbd4d39be5b00712eef17bc.png";